<template>
  <div class="cl-inner">
    <!-- 表格数据 -->
    <a-table
      :columns="columns"
      :dataSource="gradeList"
      class="c-table"
      :loading="loading"
      :rowKey="getRowKey"
    >
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="showModal(record)">升学</a>
          <a-divider type="vertical" />
          <a @click="showguidang(record)">归档</a>
        </template>
      </span>
    </a-table>
    <a-modal
      :visible="visible == 1"
      centered
      @cancel="handleCancel"
      @ok="handleOk(0)"
      :ok-button-props="{ props: { disabled: handOkDisabled } }"
      okText="确认升学"
      cancelText="取消升学"
    >
      <p class="ptb15">当前升学年级为：{{ classname }}</p>
      <p class="ptb15">
        升学目标年级为：
        <a-select
          class="form-cell"
          placeholder="请选择"
          v-model="gradeId"
          @change="changeClass"
        >
          <a-select-option
            v-for="(item, index) in gradeScopeList"
            :key="index"
            :value="item.id"
            >{{ item.tagName }}</a-select-option
          >
        </a-select>
        <a @click="smartPromotion()" class="form-btn">智能升班</a>
        <span v-if="isEditPromotion" class="form-status2">已设置</span>
        <span v-else class="form-status1">未设置</span>
      </p>
      <p v-if="tipContent.length" class="tip">{{ checkTipContent() }}</p>
      <dl class="becareful">
        <dt>注意：</dt>
        <dd>
          1.升学目标年级的原始班级数及学员数都为0时，方可正常升学
          <br />
          2.升学目标年级不能是当前升学年级
          <br />
          3.升学前，请先归档毕业年级
          <br />
          4.请谨慎操作，如果升级错误需要降级的，请至钉钉提出技术支持工单，由人工进行数据修复。
          <br />
        </dd>
      </dl>
    </a-modal>
    <a-modal
      :visible="visible == 2"
      :width="1000"
      centered
      @cancel="cancelChangeClassList"
      @ok="changeClassList"
      okText="确定"
      cancelText="取消"
    >
      <a-table
        :columns="classColumns"
        :dataSource="upClassList"
        :pagination="{ pageSize: 50, hideOnSinglePage: true }"
        class="table"
        :loading="loading"
        :scroll="{ y: 400 }"
      >
        <span
          slot="upClassName"
          slot-scope="text, record, index"
          @click="edit(record, index)"
        >
          <template>
            <a-popover
              v-if="record.className && !record.editable"
              placement="topLeft"
            >
              <template #content>
                {{ record.className }}
              </template>
              <span class="ellipsis">{{ text }}</span>
            </a-popover>
            <a-input
              v-if="record.editable"
              style="margin: -5px 0"
              placeholder="请输入预览班级名称"
              v-model="record.className"
              :maxLength="150"
              autoFocus
              @blur="blur($event, record, index)"
            />
          </template>
        </span>
      </a-table>
    </a-modal>
    <!-- 未设置智能升班确认弹窗 -->
    <a-modal
      v-model="withoutEditPromotionVisible"
      :width="500"
      centered
      @ok="upGrade()"
      okText="确认"
      cancelText="取消"
    >
      <span>未设置智能升班，确认要升学吗？</span>
      <a @click="smartPromotion()">去设置</a>
    </a-modal>
    <!-- 二次确认弹窗 -->
    <a-modal
      :visible="visible == 3"
      :width="300"
      centered
      @cancel="cancelChangeClassList"
      @ok="upGrade()"
      okText="确认"
      cancelText="取消"
    >
      <div class="form-content">确认要升学吗？</div>
    </a-modal>
    <a-modal
      v-model="guidangvisible"
      @ok="handleOk2"
      okText="确认归档"
      cancelText="取消归档"
    >
      <p class="ptb15">当前归档年级为：{{ classtitle }}</p>
      <dl class="becareful">
        <dt>注意：</dt>
        <dd>1.归档年级一旦归档将无法还原，请谨慎操作</dd>
      </dl>
    </a-modal>
  </div>
</template>
<script>
import gradeClass from '../../api/gradeClass'
const columns = [
  {
    title: '年级',
    dataIndex: 'className',
  },
  {
    title: '年级类型',
    dataIndex: 'grandType',
  },
  {
    title: '原始班级数',
    dataIndex: 'classCount',
  },
  {
    title: '学员人数',
    dataIndex: 'studentCount',
  },
  {
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
  },
]
const classColumns = [
  {
    title: 'ID',
    dataIndex: 'classId',
    width: 100,
    align: 'center',
  },
  {
    title: '原班级名',
    dataIndex: 'originalClassName',
    width: 100,
    align: 'center',
  },
  {
    title: '预览班级名称',
    dataIndex: 'className',
    scopedSlots: { customRender: 'upClassName' },
    width: 100,
    align: 'center',
  },
]
export default {
  name: 'gradeManagement',
  data() {
    return {
      queryParam: {}, //查询参数
      gradeList: [], //年级管理数据列表
      columns, //列标识数据
      loading: true,
      visible: 0,
      guidangvisible: false,
      gradeId: '请选择',
      classname: '',
      originalId: '',
      classtitle: '',
      gradeScopeList: [], // 升学目标年级选项列表
      isEditPromotion: false,
      classColumns,
      originalClassList: [], // 升班原始列表
      upClassList: [], // 升班修改列表
      withoutEditPromotionVisible: false, // 未设置智能升班确认弹窗
      scrollY: 84 * 5,
      disableIdList: [], // 目标班级数不为0时的禁用确认升学列表
      handOkDisabled: true,
      tipContent: '', // 目标班级数不为0时提示文字
    }
  },
  methods: {
    showModal(con) {
      console.log(con)
      this.tipContent = ''
      this.gradeId = '请选择'
      this.classname = con.className
      this.originalId = con.grandId
      this.disableIdList = []
      this.handOkDisabled = true
      this.getUpGradeName()
      this.visible = 1
    },
    // 查询当前升班可选择年级
    getUpGradeName() {
      let data = {
        schoolId: this.queryParam.schoolId,
        originalGradeId: this.originalId,
      }
      gradeClass.upGradeName(data).then((res) => {
        console.log(res)
        this.gradeScopeList = res.data.targetGrade
        this.originalClassList = res.data.targetClassName
        let content = []
        this.gradeScopeList.forEach((i) => {
          let res = this.gradeList.findIndex(
            (j) => i.id == j.grandId && j.classCount != 0
          )
          if (res != -1) {
            const info = this.gradeList[res]
            content.push({
              id: info.grandId,
              content: `${info.className}班级数${info.classCount}`,
            })
            this.disableIdList.push(info.grandId)
          }
        })
        this.tipContent = content
      })
    },
    // 监听切换年级
    changeClass(gradeId) {
      let res = this.disableIdList.findIndex((i) => i == gradeId)
      if (res != -1) this.handOkDisabled = true
      else this.handOkDisabled = false
      if (this.originalClassList[gradeId]) {
        let upClassList = [...this.originalClassList[gradeId]]
        upClassList.forEach((i) => (i.editable = false))
        console.log(upClassList)
        this.upClassList = upClassList
      } else {
        this.upClassList = []
      }
      this.isEditPromotion = false
    },
    // 打开智能升班弹窗
    smartPromotion() {
      if (this.gradeId == '请选择') {
        this.$message.error('请选择升学目标年级')
      } else if (!this.upClassList.length) {
        this.$message.error('当前升学年级暂无班级')
      } else {
        this.withoutEditPromotionVisible = false
        this.visible = 2
      }
    },
    // 编辑备注 显示input
    edit(record, target) {
      if (target != -1) {
        this.upClassList[target].editable = true
        this.upClassList[target].focus = true
        this.$forceUpdate()
      }
    },
    // 备注input失去焦点
    blur(e, record, target) {
      if (target != -1) {
        this.upClassList[target].editable = false
        this.upClassList[target].focus = false
        this.upClassList[target].className =
          this.upClassList[target].className.trim()
        this.$forceUpdate()
      }
    },
    // 确定修改智能升班
    changeClassList() {
      this.isEditPromotion = true
      this.visible = 1
    },
    // 取消修改智能升班
    cancelChangeClassList() {
      this.visible = 1
    },
    handleOk(type) {
      if (this.gradeId == '请选择') {
        this.$message.error('请选择升学目标年级')
      } else if (!this.isEditPromotion) {
        this.withoutEditPromotionVisible = true
      } else {
        this.visible = 3
      }
    },
    upGrade() {
      if (!this.upClassList.length) {
        this.$message.error('当前升学年级暂无班级')
      } else {
        let upClassList = [...this.upClassList]
        upClassList.forEach((i) => (i.upClassName = i.className))
        let data = {
          schoolId: this.queryParam.schoolId,
          originalGradeId: this.originalId,
          upGradeId: this.gradeId,
          upGradeForms: JSON.stringify(upClassList),
        }
        gradeClass.upGradeV2(data).then((res) => {
          this.$message.success('升学成功')
          this.handleCancel()
          this.getgradeList(this.queryParam)
        })
      }
    },
    handleCancel() {
      this.visible = 0
      this.withoutEditPromotionVisible = false
      this.isEditPromotion = false
      this.originalClassList = []
      this.upClassList = []
    },
    showguidang(res) {
      this.classtitle = res.className
      this.originalId = res.grandId
      this.guidangvisible = true
    },
    handleOk2() {
      let data = {
        gradeId: this.originalId,
        schoolId: this.queryParam.schoolId,
      }
      gradeClass.archive(data).then((res) => {
        this.$message.success('归档成功')
        this.guidangvisible = false
        this.getgradeList(this.queryParam)
      })
    },
    getgradeList(params) {
      this.loading = true
      gradeClass.getgradeList(params).then((res) => {
        console.log('当前年级管理列表', res.data)
        this.gradeList = res.data
        this.loading = false
      })
    },
    checkTipContent() {
      console.log('tipContent', this.tipContent)
      if (this.gradeId) {
        let idx = this.tipContent.findIndex((i) => i.id == this.gradeId)
        if (idx != -1)
          return `${this.tipContent[idx].content},无法统一将当前年级班级全部升级或降级,请确认目标年级班级数为0`
        else return
      }
    },
    getRowKey(record, index) {
      return index;
    },
  },
  created() {
    this.$store.dispatch('getUserInfo').then((res) => {
      this.queryParam.schoolId = res.schoolId
      this.getgradeList(this.queryParam)
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}
.search-oper {
  button {
    margin: 0px 5px;
  }
}
.list-oper {
  margin: 20px 0px 30px;
  > .item {
    display: inline-block;
    margin-left: 20px;
  }
}
.price-scope {
  width: 100px;
  text-align: center;
}
.max-price {
  border-left: none;
}
.price-gap {
  width: 30px;
  border-left: 0;
  pointer-events: none;
  background: #fff;
}
.import-excel {
  display: inline-block;
  margin-left: 20px;
  position: relative;
}
.becareful {
  position: relative;
  padding-left: 50px;
  margin-top: 20px;
}
.becareful dt {
  position: absolute;
  left: 0;
  top: 0;
  line-height: 30px;
}
.becareful dd {
  line-height: 30px;
}
.ptb15 {
  padding: 15px 0;
}
.form-btn {
  color: #4190f7;
  margin-left: 20px;
}
.form-status1 {
  color: #ff0000;
  margin-left: 10px;
}
.form-status2 {
  color: #65c498;
  margin-left: 10px;
}
.form-content {
  width: 100%;
  padding: 10px 0;
}
.table {
  max-height: 600px;
  margin: 20px 0 0;
  // overflow: auto;
}
.tip {
  color: #ff0000;
}
</style>
